import Legacy from '@/core/legacy'
import Views from '@/views'

// Import base style sheet
import "@/assets/css/base.less"

Legacy.init()
Views.render(document.getElementById("app"))